(function () {
  'use strict';
  if (window.__vbHeaderSearch) return;
  window.__vbHeaderSearch = true;

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  function debounce(fn, wait) {
    var t; return function () { var c = this, a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function imgOf(p) {
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (typeof p.image === 'string') return p.image;
    if (p.image && p.image.url) return p.image.url;
    return '';
  }
  function priceHtml(p) {
    var v = p.price;
    if (typeof v === 'string' && /[^\d.,\s]/.test(v)) return '<span class="vb-search-price">' + esc(v) + '</span>';
    return '';
  }
  function render(box, products, q) {
    var html = '';
    if (!products.length) {
      html += '<div class="vb-search-empty">Nessun risultato per “' + esc(q) + '”</div>';
    } else {
      products.forEach(function (p) {
        var img = imgOf(p);
        html += '<a class="vb-search-item" href="' + esc(p.url) + '" role="option">'
          + (img ? '<img class="vb-search-thumb" src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">'
                 : '<span class="vb-search-thumb vb-search-thumb--empty"></span>')
          + '<span class="vb-search-info"><span class="vb-search-title">' + esc(p.title) + '</span>'
          + priceHtml(p) + '</span></a>';
      });
    }
    html += '<a class="vb-search-all" href="/search?q=' + encodeURIComponent(q) + '">Vedi tutti i risultati</a>';
    box.innerHTML = html;
    box.hidden = false;
  }
  function bind(form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-vb-search-results]');
    if (!input || !box || form.__vbBound) return;
    form.__vbBound = true;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(box, prods, q);
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {});
    }, 250);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { box.hidden = true; input.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) { box.hidden = true; input.setAttribute('aria-expanded', 'false'); } });
  }
  function closeLocOnOutside(e) {
    document.querySelectorAll('details.vb-loc[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  }
  function init() {
    document.querySelectorAll('form[data-vb-search]').forEach(bind);
    document.addEventListener('click', closeLocOnOutside);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
